<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="serType">
      <form action="/">
        <van-search v-model="search.key" placeholder="请输入姓名、邮箱、手机号搜索" @search="onSelect" @cancel="onSelect" />
      </form>
      <van-dropdown-menu class="serTypeBar" active-color="#E32119">
        <van-dropdown-item v-model="search.isAsc" :options="optionSort" @change="selectTypeClose" />
        <van-dropdown-item v-model="search.myself" :options="optionState" @change="selectTypeClose" />
      </van-dropdown-menu>
    </div>
    <div class="listBody">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.userTextbookId" class="textbooks" @click="onLookteachingProgress(item.userTextbookId)">
          <van-row>
            <van-col span="14">
              课程:{{ item.courseName }}<br>
              教练:{{ item.proUserName }}</van-col>
            <van-col span="10">
              注册时间:{{ formatDate(item.regTime,"yyyy-MM-dd",true) }}<br>
              教练编号:{{ item.proUserId }}</van-col>
          </van-row>

          <van-row v-if="item.user">
            <van-col span="14">学员:{{ item.user.firstName }} {{ item.user.lastName }}
              <br>
              邮箱:{{ item.user.email }}
            </van-col>
            <van-col span="10">生日:{{ formatDate(item.user.birthday,"yyyy-MM-dd") }}<br>
              性别:{{ item.user.sex }}</van-col>
          </van-row>
        </div>
      </van-list>
    </div>
  </div></template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, formatDate, GetEnumText } from '@/utils/base'
import { DropdownMenu, DropdownItem, List, Button, Search } from 'vant'
export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [Button.name]: Button,
    [Search.name]: Search,
    TopBar
  },
  data() {
    return {
      title: '教学进度跟踪',
      backurl: '/users/index',
      list: [],
      loading: false,
      finished: false,
      search: {
        isAsc: false,
        limit: 30,
        page: 1,
        myself: true,
        key: undefined
      },
      optionSort: [
        { text: '正序', value: true },
        { text: '倒序', value: false }
      ],
      optionState: [
        { text: '自己', value: true },
        { text: '全部', value: false }
      ]
    }
  },

  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.list = []
    this.onLoad()
  },
  methods: {
    formatDate,
    GetEnumText,
    selectTypeClose() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLookteachingProgress(id) {
      this.$router.replace('/textbook/teachingProgressOne/' + id + '?backurl=/textbook/teachingProgressList')
    },
    onSelect() {
      this.search.page = 1
      this.list = []
      this.onLoad()
    },
    onLoad() {
      this.loading = true
      request({
        url: '/Course/getTeachingProgressList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }
  }
}
</script>
<style scoped>
.serType{
 position: fixed;
    left: 0;
    top: 3em;
    right: 0;
    height: 5em;
    z-index: 10;
}
.listBody{
   margin-top: 7em;

}
.textbooks{
  margin-top: 0.8em;
  font-size: 0.9em;
  line-height: 1.6em;
  padding: 0.5em 1em;
  background-color: #fff;
  border-top: 1px solid #ddd;
}
</style>
